/* eslint-disable no-param-reassign */
import { URLValidationRegex } from '../constants';
import { EmbedErrors } from '../constants/errorConsts/errorCodesConsts';

export enum EmbedChannelTypes {
  Client = 'client',
  Company = 'company',
}

const autoSizeElementTypes = ['div', 'iframe'];

export const createIFrame = (embedURL: string) =>
  `<iframe src="${embedURL}"></iframe>`;

interface CreateEmbedBodyInput {
  embedCode: string;
  autoSize: boolean;
  authEmbedData?: {
    channelType: EmbedChannelTypes;
    entityId: string;
  };
}

export const DefaultChannelTypes = [
  {
    label: 'Individual client channels',
    value: EmbedChannelTypes.Client,
  },

  {
    label: 'Company channels',
    value: EmbedChannelTypes.Company,
  },
];

export const createEmbedBody = ({
  embedCode,
  autoSize,
  authEmbedData,
}: CreateEmbedBodyInput) => {
  const urlRegex = new RegExp(URLValidationRegex);
  let embedSnippet = embedCode;
  if (embedCode.match(urlRegex)) {
    let url: URL;
    try {
      url = new URL(embedCode);
    } catch (ex) {
      console.error('Embed code is not a valid url', embedCode, ex);
      return EmbedErrors.errorRenderExtension;
    }

    // when authEmbedData is we either add clientId or companyId to the url
    // based on the channelType
    if (authEmbedData) {
      if (authEmbedData.channelType === 'company') {
        url.searchParams.set('companyId', authEmbedData.entityId);
      } else {
        url.searchParams.set('clientId', authEmbedData.entityId);
      }
    }
    // get full url and create Iframe snippet
    embedSnippet = createIFrame(url.toString());
  }

  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(embedSnippet, 'text/html');

  // override iframes that have `no` scrolling behavior
  // the explicit check for scrolling=no is recommended since this property
  // is deprecated and we dont want to set the value if it does not need to be
  Array.from(htmlDoc.body.children).forEach(elem => {
    const elemTagName = elem.tagName.toLowerCase();
    if (elemTagName === 'iframe') {
      const iframeScrollingAttributeValue = elem.getAttribute('scrolling');
      if (iframeScrollingAttributeValue === 'no') {
        (elem as HTMLIFrameElement).scrolling = 'auto';
      }
    }
  });

  if (!autoSize) {
    return htmlDoc.body.innerHTML;
  }

  let resizeHeight = '100%';
  const resizeAbleElements = Array.from(htmlDoc.body.children).filter(elem =>
    autoSizeElementTypes.includes(elem.tagName.toLowerCase()),
  );
  if (resizeAbleElements.length > 1) {
    // If there are more than one resize-able element, we'll set the height to
    // 50%, to show multiple elements on the page
    resizeHeight = '50%';
  }
  Array.from(htmlDoc.body.children).forEach(elem => {
    const elemTagName = elem.tagName.toLowerCase();
    if (!autoSizeElementTypes.includes(elemTagName)) {
      return;
    }
    //
    if (elemTagName === 'div') {
      elem.style.height = resizeHeight;
      elem.style.width = '100%';
    }
    if (elemTagName === 'iframe') {
      elem.height = resizeHeight;
      elem.width = '100%';
    }
  });

  return htmlDoc.body.innerHTML;
};
